import { Button, ButtonGroup } from '@mui/material';

import { PaymentTypes } from '../../CODForm.interface';

interface PaymentTypeToggleButtonProps {
  paymentEventType: string;
  onTogglePaymentEventType: (method: PaymentTypes) => void;
}

export const PaymentTypeToggleButton = (
  props: PaymentTypeToggleButtonProps,
) => {
  const buttons: { label: string; value: PaymentTypes }[] = [
    {
      label: 'Unlinked payment',
      value: PaymentTypes.UNLINKED_PAYMENT,
    },
    {
      label: 'Linked payment',
      value: PaymentTypes.LINKED_PAYMENT,
    },
  ];

  return (
    <ButtonGroup fullWidth>
      {buttons.map(({ label, value }) => (
        <Button
          key={value}
          variant={props.paymentEventType === value ? 'contained' : 'outlined'}
          onClick={(event) => {
            props.onTogglePaymentEventType(value);
            event.stopPropagation();
          }}>
          {label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
